document.querySelectorAll('[data-copy-layout-link]').forEach((button) => {
  button.addEventListener('click', async () => {
    const original = button.textContent;
    try {
      await navigator.clipboard.writeText(window.location.href);
      button.textContent = 'Link copied';
      window.setTimeout(() => { button.textContent = original; }, 1800);
    } catch (_error) {
      window.location.hash = 'top';
    }
  });
});
